import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-omise-payments',
  templateUrl: './omise-payments.component.html',
  styleUrls: ['./omise-payments.component.scss']
})
export class OmisePaymentsComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // Omise.publicKey('')]
    // $.getScript('https://cdn.omise.co/omise.js.gz');
  }
}
